<template>
  <b-container>
    <b-row class="mt-5">
      <b-col cols="3" offset="4">
        <b-form>
          <b-form-group label="账号：">
            <b-form-input v-model="form.username"></b-form-input>
          </b-form-group>
          <b-form-group label="密码：">
            <b-form-input v-model="form.password" type="password"></b-form-input>
          </b-form-group>
          <b-button variant="primary" @click="submit">登录</b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  export default {
    name: "LoginPage",
    data () {
      return {
        loginUrl: this.getDomain() + 'article/login',
        form: {}
      }
    },
    methods: {
      submit () {
        let handle = res => {
          sessionStorage.token = res.data.data.token;
          this.$router.push('/index/list')
        };
        this.__axios(this.loginUrl, this.form, handle)
      }
    }
  }
</script>

<style scoped>

</style>
